import { Settings } from '../components/Settings';
import { Dashboard } from '../components/Dashboard';
import store from 'react/redux/store/store';
import Globals from 'components/Globals';
import StateHelpers from "../react/redux/store/StateHelpers";
import * as windowFocusActions from "../react/redux/actions/windowFocus";
import { isNetplayPageActive } from 'react/netplay/netplayPageState';

export class MatchSounds {
	static playingSoundEffect = false;

	static limitSoundEffectsForAMoment() {
		if(!MatchSounds.playingSoundEffect) {
			MatchSounds.playingSoundEffect = true;
			setTimeout(() => {
				MatchSounds.playingSoundEffect = false;
			}, 5000);
		}
	}

	static playMatchRequestNotification() {
		if(isNetplayPageActive() && !MatchSounds.playingSoundEffect && Settings.isChecked('play_notifications')) {
			MatchSounds.limitSoundEffectsForAMoment();
			MatchSounds.playSound('#challenger');
		}
	}

	// On any page: the match dock announces the opponent's host code wherever
	// the player is (react/match/hostCode/alertHostCode).
	static hostCode() {
		if(Settings.isChecked('play_notifications')) {
			MatchSounds.playSound('#hostcode', .3);
		}
	}

	static playJingles() {
		if(isNetplayPageActive() && Settings.isChecked('play_notifications')) {
			MatchSounds.playSound('#jingles');
		}
	}

	static playStickiedMatch() {
		if(isNetplayPageActive() && Settings.isChecked('play_notifications')) {
			MatchSounds.playSound('#stickied_match');
		}
	}

	static playModNotification() {
		if(isNetplayPageActive() && Settings.isChecked('play_notifications')) {
			MatchSounds.playSound('#enter', .1);
		}
	}

	static playPrivateMessageSoundEffect() {

		if(isNetplayPageActive() && !MatchSounds.playingSoundEffect && Settings.isChecked('play_notifications')) {
			MatchSounds.limitSoundEffectsForAMoment();
			MatchSounds.playSound('#private_message_sound');
		}
	}

	static playSubHypeSoundEffect(type) {
		if(isNetplayPageActive() && !MatchSounds.playingSoundEffect && Settings.isChecked('sub_hype_notification_sound') && StateHelpers.windowIsFocused()) {
			MatchSounds.limitSoundEffectsForAMoment();
			switch(type) {
				case 'bumped': {
					MatchSounds.playSound('#sub_hype_sound_bumped', .2);
					break;
				}
				case 'thumped': {
					MatchSounds.playSound('#pokeballin', .2);
					break;
				}
				default: {
					MatchSounds.playSound('#sub_hype_sound');
				}
			}
		}
	}

	static playSound(soundSelector, volume = 1.0) {
		if(!Globals.finishedStartup) {
			return;
		}
		let soundElement = MatchSounds.cachedElements[soundSelector];
		if(soundElement === undefined) {
			soundElement = $(soundSelector);
			if(soundElement.length) {
				soundElement = soundElement[0];
				MatchSounds.cachedElements[soundSelector] = soundElement;
			}
			else {
				soundElement = null;
				MatchSounds.cachedElements[soundSelector] = null;
			}
		}
		if(!soundElement) {
			console.error('[AUDIO] sound element ' + soundSelector + ' Not found!');
			return;
		}
		if(soundElement.paused) {
			soundElement.volume = volume;

			audioUnlocker.attemptToUnlockAudio(soundElement);
			const playPromise = soundElement.play();

			playPromise
				.then(() => {
					store.dispatch(windowFocusActions.windowAudioSuccess());
				})
				.catch((error) => {
					store.dispatch(windowFocusActions.windowAudioError());
					console.log('[AUDIO] Sound play error');
					console.error(error);
				});
		}
	}
}

class AudioContextUnlocker {
	constructor() {
		this.attemptingToUnlock = false;
		this.unlockedOnce = false;
		this.audioContext = null;

		this.attemptToUnlockAudio = this.attemptToUnlockAudio.bind(this);
		this.unlockAudioContext = this.unlockAudioContext.bind(this);
	}

	attemptToUnlockAudio(soundElement) {
		if(!window.AudioContext && !window.webkitAudioContext) {
			console.error('[AUDIO] No audio context to attempt to unlock!');
			return;
		}
		if(!this.audioContext) {
			this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
		}
		this.unlockAudioContext(this.audioContext, soundElement);
	}

	unlockAudioContext(audioCtx, soundElement) {
		// console.log('[AUDIO] attempting to unlock audio capabilities');
		if(audioCtx.state !== 'suspended') {
			// console.log('[AUDIO] Audio is already unlocked! We are good to go');
			this.unlockedOnce = true;
			return;
		}
		if(this.attemptingToUnlock) {
			console.error('[AUDIO] Already attempting to unlock, do not need to attach event listeners again');
		}
		if(this.unlockedOnce) {
			console.error('[AUDIO] Unlocked before, attempting to unlock again after playback error!');
		}

		console.log('[AUDIO] ATTACHING INTERACTION LITERNERS!');
		this.attemptingToUnlock = true;
		const events = ['touchstart', 'touchend', 'mousedown', 'click', 'keydown'];

		const unlock = () => {
			console.log('[AUDIO] Triggering Unlock - Awkawrdly playing stored sound on next user interaction');
			if(soundElement) {
				soundElement.play();
				console.log('[AUDIO] really!');
			}
			else {
				console.log('[AUDIO] just kidding');
			}
			audioCtx.resume().then(clean);
		};

		const clean = () => {
			console.log('[AUDIO] Cleanup unlock code!');
			this.attemptingToUnlock = false;
			this.unlockedOnce = true;
			events.forEach(eventName => {
				console.log('[AUDIO] removing', eventName);
				document.body.removeEventListener(eventName, unlock);
			});
		};

		events.forEach(eventName => {
			console.log('[AUDIO] adding?!', eventName);
			document.body.addEventListener(eventName, unlock, false);
		});
	}
}

const audioUnlocker = new AudioContextUnlocker();

MatchSounds.cachedElements = {};